var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_792_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.03738 0 0 4.03738 0 9C0 13.9626 4.03738 18 9 18C13.9626 18 18 13.9626 18 9C18 4.03738 13.9626 0 9 0ZM9 16.875C4.65771 16.875 1.125 13.3423 1.125 9C1.125 4.65771 4.65771 1.125 9 1.125C13.3423 1.125 16.875 4.65771 16.875 9C16.875 13.3423 13.3423 16.875 9 16.875ZM13.741 11.7422C12.7576 13.4453 10.9853 14.4622 9.00014 14.4622C7.0149 14.4622 5.2425 13.4454 4.259 11.7422C4.10365 11.4732 4.19579 11.1291 4.46481 10.9738C4.73389 10.8185 5.0779 10.9106 5.23318 11.1796C6.01334 12.5306 7.42155 13.3372 9.0001 13.3372C10.5786 13.3372 11.9867 12.5306 12.7668 11.1796C12.9221 10.9106 13.2661 10.8184 13.5352 10.9738C13.8042 11.1291 13.8964 11.4731 13.741 11.7422ZM4.17227 6.78315C4.17227 6.16257 4.67715 5.65766 5.29777 5.65766C5.91838 5.65766 6.42326 6.16254 6.42326 6.78315C6.42326 7.40377 5.91838 7.90864 5.29777 7.90864C4.67715 7.90864 4.17227 7.40377 4.17227 6.78315ZM13.8278 6.78315C13.8278 7.40373 13.3229 7.90864 12.7023 7.90864C12.0817 7.90864 11.5768 7.40377 11.5768 6.78315C11.5768 6.16254 12.0817 5.65766 12.7023 5.65766C13.3228 5.6577 13.8278 6.16257 13.8278 6.78315Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_792_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmote);
export default __webpack_public_path__ + "static/media/emote.b109b1ec3d8e4c96bb4c7132be2a0f39.svg";
export { ForwardRef as ReactComponent };